export default __webpack_public_path__ + "images/9290dd1b685eb50d09bea50256d049cf-bg-06.jpg";